/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Styles from './EmprestimoGarantiaCarro.css';
import EmprestimoGarantiaCarroOQueE from '@/components/organisms/EmprestimoGarantiaCarroOQueE';
import EmprestimoGarantiaCarroPorQue from '@/components/organisms/EmprestimoGarantiaCarroPorQue';
import EmprestimoGarantiaCarroMaisLonge from '@/components/organisms/EmprestimoGarantiaCarroMaisLonge';
import EmprestimoGarantiaCarroCompare from '@/components/organisms/EmprestimoGarantiaCarroCompare';
import EmprestimoGarantiaCarroCreditoSeguro from '@/components/organisms/EmprestimoGarantiaCarroCreditoSeguro';
import EmprestimoGarantiaCarroSaber from '@/components/organisms/EmprestimoGarantiaCarroSaber';
import EmprestimoGarantiaCarroTemContrato from '@/components/organisms/EmprestimoGarantiaCarroTemContrato';

function EmprestimoGarantiaCarro({ show }) {
  return (
    <>
      <main id="page-emprestimo-garantia" className={show ? 'show' : ''}>
        <EmprestimoGarantiaCarroOQueE />
        <EmprestimoGarantiaCarroPorQue />
        <EmprestimoGarantiaCarroTemContrato />
        <EmprestimoGarantiaCarroMaisLonge />
        <EmprestimoGarantiaCarroCompare />
        <EmprestimoGarantiaCarroCreditoSeguro />
        <EmprestimoGarantiaCarroSaber />
      </main>
      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarro;
